import { render, staticRenderFns } from "./ChatbotWrapper.vue?vue&type=template&id=0a3496b8&scoped=true&"
import script from "./ChatbotWrapper.vue?vue&type=script&lang=js&"
export * from "./ChatbotWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3496b8",
  null
  
)

export default component.exports